import mixpanel from 'mixpanel-browser';

let mixpanelInitialized = false;

const MIXPANEL_DEBUG = process.env.NODE_ENV === 'development';
const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;

export const initializeAnalytics = async () => {
    try {
        if (typeof window !== 'undefined' && !mixpanelInitialized && MIXPANEL_TOKEN) {
            mixpanel.init(MIXPANEL_TOKEN, {
                debug: MIXPANEL_DEBUG,
                // Persist queue so purchase events survive quick redirects.
                persistence: 'localStorage',
                batch_requests: false,
            });
            mixpanelInitialized = true;
        }
    } catch (error) {
        console.error('Failed to initialize analytics:', error);
    }
};

export const getAnalytics = () => {
    if (typeof window === 'undefined') {
        // Server-side: return null for mixpanel to avoid errors
        return { mixpanel: null };
    }

    if (!mixpanelInitialized) {
        initializeAnalytics();
    }
    return { mixpanel: mixpanelInitialized ? mixpanel : null };
};
